import * as httpUtil from "@/utils/httpUtil";
const interfaces: Array<Record<string, any>> = [
  {
    //desc: "首页装修",
    method: "post",
    name: "doctorFitmentIndex",
    url: "/medicine/fitment/indexV2",
  },
  {
    //desc: "保存社区装修",
    method: "post",
    name: "doctorFitmentSaveModule",
    url: "/medicine/fitment/saveModuleV2",
  },
  {
    //desc: "查询医学首页上下架配置",
    method: "post",
    name: "getHomePageMedicineConfig",
    url: "/c/pc/homePage/medicine/getConfig",
  },
  {
    //desc: "编辑医学首页上下架配置",
    method: "post",
    name: "updateHomePageMedicineConfig",
    url: "/c/pc/homePage/medicine/updateConfig",
  },
  {
    //desc: "查询医学首页访问控制",
    method: "post",
    name: "getMedicineAccessControlConfig",
    url: "/c/pc/homePage/medicineAccessControl/getConfig",
  },
  {
    //desc: "编辑医学首页访问控制",
    method: "post",
    name: "updateMedicineAccessControlConfig",
    url: "/c/pc/homePage/medicineAccessControl/updateConfig",
  },
];

function exportsRender(interfacesArr: Array<Record<string, any>>) {
  const resultExports: Record<string, any> = {};
  interfacesArr.map((item: Record<string, any>) => {
    resultExports[item.name] = (data: Record<string | number, any>) => {
      return (httpUtil as Record<string, any>)[item.method](item.url, data, item.config);
    };
  });
  return resultExports;
}

export default exportsRender(interfaces);
